import { defineMessages } from "react-intl";
import { node as cardiovascularDiseases } from "src/modules/ltx/forms/phase-i/medical-history/comorbidities/cardiovascularDiseases";
import { node as endocrineDiseases } from "src/modules/ltx/forms/phase-i/medical-history/comorbidities/endocrineDiseases";
import { node as gastrointestinalDiseases } from "src/modules/ltx/forms/phase-i/medical-history/comorbidities/gastrointestinalDiseases";
import { node as nephrologicalAndUrologicalDiseases } from "src/modules/ltx/forms/phase-i/medical-history/comorbidities/nephrologicalAndUrologicalDiseases";
import { node as respiratoryAndPulmonaryDiseases } from "src/modules/ltx/forms/phase-i/medical-history/comorbidities/respiratoryAndPulmonaryDiseases";
import { node as surgicalProcedures } from "src/modules/ltx/forms/phase-i/medical-history/comorbidities/surgicalProcedures";
import { node as thrombophilia } from "src/modules/ltx/forms/phase-i/medical-history/comorbidities/thrombophilia";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.comorbidities",
		defaultMessage: "Társbetegségek"
	}
});

export const node: ParentNode = {
	id: "comorbidities",
	value: { type: "list", title: messages.title },
	children: [
		cardiovascularDiseases,
		endocrineDiseases,
		gastrointestinalDiseases,
		nephrologicalAndUrologicalDiseases,
		respiratoryAndPulmonaryDiseases,
		surgicalProcedures,
		thrombophilia
	]
};
